import React from "react";
import PageTitle from "../api/PageTitle";
import FaqLeft from '../components/FaqLeft'

const Faq = () => {
  return (
    <>
      <PageTitle name="FAQ" link="Home" page="Faq" />
      <section className="faq-wrapper">
        <div className="faq-left">
          <FaqLeft />
        </div>
      </section>
    </>
  );
};

export default Faq;
